import {
  courseNameList,
  courseDocumentList,
  courseList,
  courseRatingsList,
} from "constants/course";
import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponents/CommonFunctions";
import { channelPartnerEnrolledCourseList } from "constants/channelPartner";
import { channelPartnerCoursePendingEnrolledList, enrolledChannelPartnerListAgainstCourse } from "constants/course";

export const addCourseName = async (bodyData) => {
  try {
    const res = await api.add_course_name(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const getCourseNameList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.get_course_name_list(pageNum, filters);
    dispatch({ type: courseNameList, payload: res?.data });
  } catch (error) {
    dispatch({
      type: courseNameList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error?.response?.data);
  }
};

export const addCourseDocument = async (bodyData) => {
  try {
    const res = await api.add_course_document(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const getCourseDocumentList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.get_course_document_list(pageNum, filters);
    dispatch({ type: courseDocumentList, payload: res?.data });
  } catch (error) {
    dispatch({
      type: courseDocumentList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error?.response?.data);
  }
};

export const deleteCourseName = async (courseNameID) => {
  try {
    const res = await api.delete_course_name(courseNameID);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const addCourse = async (bodyData) => {
  try {
    const res = await api.add_course(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const getCourseList = async (dispatch, pageNum, filterParams, searchString, sortOptionJSON) => {
  try {
    const res = await api.get_course_list(pageNum, filterParams, searchString, sortOptionJSON);
    dispatch({ type: courseList, payload: res.data });
  } catch (error) {
    authorizedUser(error?.response?.data);
    dispatch({
      type: courseList,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};

export const getCourseById = async (id) => {
  try {
    const res = await api.get_course_by_id(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const inactiveCourseBatches = async (id) => {
  try {
    const res = await api.inactive_course_batches(id);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};


//get the course batch enroll details by id
export const getCourseBatchDetailByID = async (id) => {
  try {
    const res = await api.get_course_batch_details(id);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

//Enrolled Trainee Course
export const EnrolledCourse = async (payload) => {
  try {
    const res = await api.enrolled_trainee_course(payload);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

//enroll payment
export const CourseEnrollmentPayment = async (payload) => {
  try {
    const res = await api.enrollment_payment(payload);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};




//Get Enrolled Courses List
export const getChannelPartnerEnrolledCourseList = async (dispatch, pageNum, filterParams, searchString, sortOptionJSON) => {
  try {
    const res = await api.get_channel_partner_enrolled_course_list(pageNum, filterParams, searchString, sortOptionJSON);
   
    
    dispatch({ type: channelPartnerEnrolledCourseList, payload: res?.data });
  } catch (error) {
    authorizedUser(error?.response?.data);
    dispatch({
      type: channelPartnerEnrolledCourseList,
      payload: error?.response?.data ?? { message: error?.message },})
    }
  }    
      
  export const getCourseRatings = async (dispatch, courseId, pageNum) => {
        try {
          const res = await api.get_course_ratings(courseId, pageNum);
          dispatch({ type: courseRatingsList, payload: res?.data });
        } catch (error) {
          authorizedUser(error?.response?.data);
          dispatch({
            type: courseRatingsList,
            payload: error?.response?.data || error,
          });
        }
      };
//Get Enrolled Course Schedule
export const getChannelPartnerEnrolledCourseScheduleDetails = async (payload) => {
  try {
    const res = await api.get_course_schedule_details(payload);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

//Get course Reviews
export const getCourseReviews = async (id) => {
  try {
    const res = await api.get_course_reviews(id);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};


//Course Attendance 
export const channelPartnerTraineeCourseAttendance = async (courseId, batchId) => {
  try {
    const res = await api.channel_partner_trainee_enrolled_course_attendance(courseId, batchId);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};


//Course Feedback 
export const channelPartnerAddCourseRating = async (data) => {
  try {
    const res = await api.add_course_rating(data);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};


//Course Attendance 
export const channelPartnerCourseEnrollmentDetails = async (courseId) => {
  try {
    const res = await api.get_channel_partner_course_enrollment_details(courseId);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

//Get course pending enroll trainee
export const getCoursePendingEnrollTrainees = async (
  courseId,
  dispatch,
  pageNum,
  filterParams,
  searchString,
  sortOptionJSON
) => {
  try {
    const res = await api.get_pending_enrolled_trainees(courseId,pageNum, filterParams, searchString, sortOptionJSON);
    dispatch({
      type: channelPartnerCoursePendingEnrolledList,
      payload: res.data,
    });
  } catch (error) {
    authorizedUser(error?.response?.data);
    dispatch({
      type: channelPartnerCoursePendingEnrolledList,
      payload: error?.response?.data ?? {
        message: error?.message,
      },
    });
  }
};




//Get enrolled trainees list against course
export const getEnrolledTraineesListAgainstCourse = async (
  courseId,
  dispatch,
  pageNum,
  filterParams,
  searchString,
  sortOptionJSON
) => {
  try {
    const res = await api.get_enrolled_trainees_list_against_course(courseId,pageNum, filterParams, searchString, sortOptionJSON);
    dispatch({
      type: enrolledChannelPartnerListAgainstCourse,
      payload: res.data,
    });
  } catch (error) {
    authorizedUser(error?.response?.data);
    dispatch({
      type: enrolledChannelPartnerListAgainstCourse,
      payload: error?.response?.data ?? {
        message: error?.message,
      },
    });
  }
};
export const deleteCourseRating = async (id) => {
  try {
    const res = await api.delete_course_rating(id);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

//Upcoming Course Batches
export const courseUpcomingBatches = async (courseId) => {
  try {
    const res = await api.get_course_upcoming_batches(courseId);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getChannelPartnerCourseList = async (dispatch, pageNum, filterParams, searchString, sortOptionJSON) => {
  try {
    const res = await api.get_channel_partner_course_list(pageNum, filterParams, searchString, sortOptionJSON);
    dispatch({ type: courseList, payload: res.data });
  } catch (error) {
    authorizedUser(error?.response?.data);
    dispatch({
      type: courseList,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};